module.exports = __webpack_public_path__ + "img/bdlb-b.d5ad6dc6.png";